
import React, { useEffect, useState, useMemo } from "react";

import {
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  CircularProgress,
  Tooltip,
  Paper,
  InputBase,
  Divider,
  Fab,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";


function SearchBar({ query, setQuery, disabled }) {
  return (
    <Paper
      sx={{
        p: "2px 4px",
        display: "flex",
        alignItems: "center",
        mb: 2,
        mt: 2,
        bgcolor: "#e4e6e6ff",
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder="Wyszukaj model"
        value={query}
        disabled={disabled}
        onChange={(e) => setQuery(e.target.value)}
      />

      <Divider
        sx={{ height: 28, m: 0.5 }}
        orientation="vertical"
      />

      <SearchIcon color="primary" />

    </Paper>
  );
}



export default function ModelList({
  addModel,
  MODEL_LIBRARY
}) {


  const [models, setModels] = useState([]);

  const [loading, setLoading] = useState(true);

  const [selectedCategory, setSelectedCategory] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");



  const sections = [
    {
      name: "Przygotowywanie potraw zgodnie z trendami rynkowymi i zasadami zdrowego żywienia",
      elements: [
        "exe_cooking_cook_station",
        "exe_cooking_cookbase",
        "exe_cooking_countertop_2",
        "exe_cooking_countertop_4",
        "exe_cooking_countertop_drawer",
        "exe_cooking_device_blender",
        "exe_cooking_device_mixer",
        "exe_cooking_device_mixer_blender",
        "exe_cooking_drawers_ingrediens",
        "exe_cooking_fridge_dairy",
        "exe_cooking_fridge_fruits",
        "exe_cooking_fridge_meat",
        "exe_cooking_fridge_vegetables",
        "exe_cooking_fridges_all",
        "exe_cooking_mech_cooker",
        "exe_cooking_mech_furnance",
        "exe_cooking_sink",
        "exe_cooking_sink_hanged",
        "exe_cooking_utensils",
        "exe_cooking_bins",
      ],
    },

    {
      name:"Meble",
      elements:[
        "envp_furnitures_table_140_80",
        "envp_furnitures_table_160_80",
        "envp_furnitures_table_250_120",
        "envp_furnitures_table_400_120",
        "envp_furnitures_sofa_corner_3_2",
        "envp_furnitures_sofa_corner_3_3",
        "envp_furnitures_sofa_line_2",
        "envp_furnitures_sofa_line_3",
        "envp_furnitures_sofa_single",
        "envp_furnitures_sofa_single_corner",
        "envp_furnitures_chair",
        "envp_furnitures_office_chair",
        "envp_bin_4",
        "envp_bin_lid",
        "whiteboard",
      ]
    },


    {
      name:"Konstrukcja",
      elements:[
        "env_wall_column_05",
        "env_wall_creator_x2_5",
        "envp_modular_door_frame",
        "exe_creator_door_office_double",
        "exe_creator_door_wooden_1",
        "elevator_1x2.1x",
        "env_staircase_stairs",
      ]
    }

  ];




  // NOWE ŹRÓDŁO DANYCH - bootstrap / Cloudflare

  useEffect(()=>{

    const visible =
      MODEL_LIBRARY.filter(
        m => m.visible !== false
      );


    setModels(visible);

    setLoading(false);


  },[MODEL_LIBRARY]);






  const modelsToDisplay = useMemo(()=>{

    if(!selectedCategory)
      return [];


    return models

      .filter(model =>
        selectedCategory.elements.includes(model.name)
      )

      .filter(model=>{

        if(searchQuery.trim()==="")
          return true;


        const query =
          searchQuery.toLowerCase();


        return (

          model.name
            ?.toLowerCase()
            .includes(query)

          ||

          model.info?.name
            ?.toLowerCase()
            .includes(query)

        );

      });


  },[
    models,
    selectedCategory,
    searchQuery
  ]);






  if(loading)
  {
    return (
      <Box
        sx={{
          display:"flex",
          justifyContent:"center",
          my:10
        }}
      >
        <CircularProgress/>
      </Box>
    );
  }






  return (

    <>

      <SearchBar
        query={searchQuery}
        setQuery={setSearchQuery}
        disabled={!selectedCategory}
      />



      <List
        dense
        sx={{
          maxHeight:300,
          overflowY:"auto"
        }}
      >



        {
          !selectedCategory &&

          sections.map(section=>(

            <ListItem
              key={section.name}
              disablePadding
            >

              <ListItemButton
                onClick={()=>{

                  setSelectedCategory(section);
                  setSearchQuery("");

                }}
              >

                <ListItemText
                  primary={section.name}
                />

              </ListItemButton>


            </ListItem>


          ))

        }







        {
          selectedCategory &&

          <Box
            sx={{
              display:"flex",
              minHeight:100
            }}
          >


            <Box
              sx={{
                pt:1,
                px:1
              }}
            >

              <Fab
                size="small"
                color="primary"
                onClick={()=>{

                  setSelectedCategory(null);
                  setSearchQuery("");

                }}
              >

                <ArrowBackIcon/>

              </Fab>


            </Box>





            <Box
              sx={{
                flex:1
              }}
            >


              {
                modelsToDisplay.map(model=>(


                  <TooltipWithDelay

                    key={model.name}

                    title={
                      model.info?.description ||
                      "Brak opisu"
                    }

                  >


                    <ListItem
                      disablePadding
                    >

                      <ListItemButton

                        onMouseDown={()=>
                          addModel(model.name)
                        }

                      >

                        <ListItemText

                          primary={
                            model.info?.name ||
                            model.name
                          }

                        />


                      </ListItemButton>


                    </ListItem>


                  </TooltipWithDelay>



                ))
              }


            </Box>



          </Box>


        }



      </List>


    </>

  );

}






function TooltipWithDelay({
  children,
  title
}){


  const [open,setOpen]=useState(false);

  let timeout;



  const handleMouseEnter=()=>{

    timeout=setTimeout(
      ()=>setOpen(true),
      800
    );

  };



  const handleMouseLeave=()=>{

    clearTimeout(timeout);

    setOpen(false);

  };



  return (

    <Tooltip

      title={title}

      open={open}

      onMouseEnter={handleMouseEnter}

      onMouseLeave={handleMouseLeave}

      disableHoverListener

      disableFocusListener

      disableTouchListener

    >

      {children}

    </Tooltip>

  );

}


// import React, { useEffect, useState, useMemo } from "react";
// import {
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemText,
//   Box,
//   CircularProgress,
//   Tooltip,
//   Paper,
//   InputBase,
//   Divider,
//   Button,
//   Fab,
// } from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// function SearchBar({ query, setQuery, disabled }) {
//   return (
//     <Paper
//       sx={{
//         p: "2px 4px",
//         display: "flex",
//         alignItems: "center",
//         mb: 2,
//         mt: 2,
//         bgcolor: "#e4e6e6ff",
//         opacity: disabled ? 0.6 : 1,
//       }}
//     >
//       <InputBase
//         sx={{ ml: 1, flex: 1 }}
//         placeholder="Wyszukaj model"
//         value={query}
//         disabled={disabled}
//         onChange={(e) => setQuery(e.target.value)}
//       />
//       <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
//       <SearchIcon color="primary" />
//     </Paper>
//   );
// }

// export default function ModelList({ addModel, MODEL_LIBRARY }) {
//   const [models, setModels] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");

//   const sections = [
//     {
//       name: "Przygotowywanie potraw zgodnie z trendami rynkowymi i zasadami zdrowego żywienia",
//       elements: [
//         "exe_cooking_cook_station",
//         "exe_cooking_cookbase",
//         "exe_cooking_countertop_2",
//         "exe_cooking_countertop_4",
//         "exe_cooking_countertop_drawer",
//         "exe_cooking_device_blender",
//         "exe_cooking_device_mixer",
//         "exe_cooking_device_mixer_blender",
//         "exe_cooking_drawers_ingrediens",
//         "exe_cooking_fridge_dairy",
//         "exe_cooking_fridge_fruits",
//         "exe_cooking_fridge_meat",
//         "exe_cooking_fridge_vegetables",
//         "exe_cooking_fridges_all",
//         "exe_cooking_mech_cooker",
//         "exe_cooking_mech_furnance",
//         "exe_cooking_sink",
//         "exe_cooking_sink_hanged",
//         "exe_cooking_utensils",
//         "exe_cooking_bins",
//       ],
//     },
//     {
//       name: "Montowanie Stolarki Budowlanej",
//       elements: [
//         "exe_wd_22bolt_22nut_impactdriver",
//         "exe_wd_22nut_impactdriver",
//         "exe_wd_combined_exercises",
//         "exe_wd_drill_26plug_26screw_impactdriver",
//         "exe_wd_drill_dowel_hammer",
//         "exe_wd_foaming",
//         "exe_wd_garage_gate_installation",
//         "exe_wd_garage_gate_supply",
//         "exe_wd_interior_door_installation",
//         "exe_wd_interior_door_supply",
//         "exe_wd_leveler",
//         "exe_wd_outer_door_installation",
//         "exe_wd_outer_door_supply",
//         "exe_wd_powerdrilldrillbit_expansionplug_woodworkscrew_powerdrill",
//         "exe_wd_roof_window_installation",
//         "exe_wd_roof_window_supply",
//         "exe_wd_strut",
//         "exe_wd_technical_door_installation",
//         "exe_wd_technical_door_supply",
//         "exe_wd_tool_rack_1",
//         "exe_wd_tool_rack_boxes",
//         "exe_wd_vertical_window_installation",
//         "exe_wd_vertical_window_supply",
//         "exe_wd_wedge_hammer",
//       ],
//     },
//     { name: "Obrona Cywilna", elements: ["exe_cd_essential_items"] },
//     {
//       name: "Programowanie i obsługiwanie procesu druku 3D",
//       elements: [
//         "exe_printing_cabinet_filament_abs_ptg",
//         "exe_printing_cabinet_filament_pla_tpu",
//         "exe_printing_cleaning_set",
//         "exe_printing_examples",
//         "exe_printing_3d_printing_station",
//       ],
//     },
//     {
//       name: "Meble",
//       elements: [
//         "envp_furnitures_table_140_80",
//         "envp_furnitures_table_160_80",
//         "envp_furnitures_table_250_120",
//         "envp_furnitures_table_400_120",
//         "envp_furnitures_table_small_75x75x75",
//         "envp_furnitures_table_small_75x75x100",
//         "envp_furnitures_table_small_100x100x75",
//         "envp_furnitures_table_small_100x100x100",
//         "envp_furnitures_table_small_125x100x75",
//         "envp_furnitures_table_small_125x100x100",
//         "envp_furnitures_sofa_corner_3_2",
//         "envp_furnitures_sofa_corner_3_3",
//         "envp_furnitures_sofa_line_2",
//         "envp_furnitures_sofa_line_3",
//         "envp_furnitures_sofa_single",
//         "envp_furnitures_sofa_single_corner",
//         "envp_furnitures_chair",
//         "envp_furnitures_office_chair",
//         "envp_bin_4",
//         "envp_bin_lid",
//         "whiteboard",
//       ],
//     },
//     {
//       name: "Konstrukcja",
//       elements: [
//         "env_wall_column_05",
//         "env_wall_creator_x2_5",
//         "envp_modular_door_frame",
//         "exe_creator_door_office_double",
//         "exe_creator_door_wooden_1",
//         "elevator_1x2.1x",
//         "env_staircase_stairs",
//       ],
//     },
//   ];

//   useEffect(() => {
//     const fetchAllModels = async () => {
//       const visibleModels = MODEL_LIBRARY.filter((m) => m.visible);

//       try {
//         const modelsWithData = await Promise.all(
//           visibleModels.map(async (model) => {
//             try {
//               const response = await fetch(
//                 `https://vralfa.vccsystem.eu/manifest/api/${model.name}.manifest&0`,
//               );

//               if (!response.ok) {
//                 console.error(
//                   `Failed to fetch ${model.name}: ${response.status}`,
//                 );
//                 return { ...model, endpointData: null };
//               }

//               const data = await response.json();
//               return { ...model, endpointData: data };
//             } catch {
//               return { ...model, endpointData: null };
//             }
//           }),
//         );

//         setModels(modelsWithData);
//       } catch (err) {
//         console.error("Błąd pobierania modeli:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAllModels();
//   }, [MODEL_LIBRARY]);

//   const modelsToDisplay = useMemo(() => {
//     if (!selectedCategory) return [];

//     return models
//       .filter((model) => selectedCategory.elements.includes(model.name))
//       .filter((model) => {
//         if (searchQuery.trim() === "") return true;

//         return model.endpointData?.info?.name
//           ?.toLowerCase()
//           .includes(searchQuery.toLowerCase());
//       });
//   }, [models, selectedCategory, searchQuery]);

//   if (loading)
//     return (
//       <Box sx={{ display: "flex", justifyContent: "center", my: 10 }}>
//         <CircularProgress />
//       </Box>
//     );

//   return (
//     <>
//       <SearchBar
//         query={searchQuery}
//         setQuery={setSearchQuery}
//         disabled={!selectedCategory}
//       />

//       <List dense sx={{ maxHeight: 300, overflowY: "auto" }}>
//         {!selectedCategory &&
//           sections.map((section) => (
//             <ListItem key={section.name} disablePadding>
//               <ListItemButton
//                 onClick={() => {
//                   setSelectedCategory(section);
//                   setSearchQuery("");
//                 }}
//               >
//                 <ListItemText primary={section.name} />
//               </ListItemButton>
//             </ListItem>
//           ))}

//         {selectedCategory && (
//           <>
           
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "flex-start",
//                 mb: 1,
//                 minHeight: 100,
//               }}
//             >
//               <Box
//                 sx={{
//                   position: "sticky",
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   left: 0,
//                   zIndex: 10,
//                   display: "flex",
//                   alignItems: "center",
//                   pl: 1,
//                 }}
//               >
//                 <Fab
//                   size="small"
//                   color="primary"
//                   aria-label="back"
//                   onClick={() => {
//                     setSelectedCategory(null);
//                     setSearchQuery("");
//                   }}
//                 >
//                   <ArrowBackIcon />
//                 </Fab>
//               </Box>

//               <Box sx={{ flex: 1, overflow: "hidden" }}>
//                 {modelsToDisplay.map((m) => (
//                   <TooltipWithDelay
//                     key={m.name}
//                     title={
//                       m.endpointData
//                         ? m.endpointData?.info?.descreption || "Brak opisu"
//                         : "Brak danych"
//                     }
//                   >
//                     <ListItem disablePadding>
//                       <ListItemButton onMouseDown={() => addModel(m.name)}>
//                         <ListItemText
//                           primary={m.endpointData?.info?.name || m.name}
//                         />
//                       </ListItemButton>
//                     </ListItem>
//                   </TooltipWithDelay>
//                 ))}
//               </Box>
//             </Box>
//           </>
//         )}
//       </List>
//     </>
//   );
// }

// function TooltipWithDelay({ children, title }) {
//   const [open, setOpen] = useState(false);
//   let timeout;

//   const handleMouseEnter = () => {
//     timeout = setTimeout(() => setOpen(true), 800);
//   };

//   const handleMouseLeave = () => {
//     clearTimeout(timeout);
//     setOpen(false);
//   };

//   return (
//     <Tooltip
//       title={title}
//       open={open}
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//       disableHoverListener
//       disableFocusListener
//       disableTouchListener
//     >
//       {children}
//     </Tooltip>
//   );
// }

// import React, { useEffect, useState } from "react";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemButton from "@mui/material/ListItemButton";
// import ListItemText from "@mui/material/ListItemText";
// import { Box, CircularProgress, Tooltip } from "@mui/material";

// import Paper from "@mui/material/Paper";
// import InputBase from "@mui/material/InputBase";
// import Divider from "@mui/material/Divider";
// import SearchIcon from "@mui/icons-material/Search";

// function SearchBar({ models, onSearch }) {
//   const [query, setQuery] = useState("");

//   const handleChange = (e) => {
//     const value = e.target.value;
//     setQuery(value);

//     if (value.trim() === "") {
//       onSearch(models);
//       return;
//     }

//     const filtered = models.filter((model) =>
//       model.endpointData?.info?.name
//         ?.toLowerCase()
//         .includes(value.toLowerCase()),
//     );

//     onSearch(filtered);
//   };

//   const searchModel = (e) => {
//     e.preventDefault();
//   };

//   const sections = [
//     {
//       name: "Meble",
//       elements: [
//         "envp_furnitures_table_140_80",
//         "envp_furnitures_table_160_80",
//         "envp_furnitures_table_250_120",
//         "envp_furnitures_table_400_120",
//         "envp_furnitures_table_small_75x75x75",
//         "envp_furnitures_table_small_75x75x100",
//         "envp_furnitures_table_small_100x100x75",
//         "envp_furnitures_table_small_100x100x100",
//         "envp_furnitures_table_small_125x100x75",
//         "envp_furnitures_table_small_125x100x100",
//         "envp_furnitures_sofa_corner_3_2",
//         "envp_furnitures_sofa_corner_3_3",
//         "envp_furnitures_sofa_line_2",
//         "envp_furnitures_sofa_line_3",
//         "envp_furnitures_sofa_single",
//         "envp_furnitures_sofa_single_corner",
//         "envp_furnitures_chair",
//         "envp_furnitures_office_chair",
//         "envp_bin_4",
//         "envp_bin_lid",
//       ],
//     },
//     {
//       name: "Gotowanie",
//       elements: [
//         "env_countertop_flat_optimized_drawers",
//         "env_sink",
//         "env_sink_hanged_soap",
//         "exe_cooking_countertop_2",
//         "exe_cooking_countertop_4",
//         "exe_cooking_drawers_ingrediens",
//         "exe_cooking_fridges_all",
//         "exe_cooking_utensils",
//         "mech_cooker",
//         "mech_furnace_1",
//         "envp_bin_4_lids",
//       ],
//     },
//     {
//       name: "Stolarka",
//       elements: [
//         "exe_wd_22bolt_22nut_impactdriver",
//         "exe_wd_22nut_impactdriver",
//         "exe_wd_combined_exercises",
//         "exe_wd_drill_26plug_26screw_impactdriver",
//         "exe_wd_drill_dowel_hammer",
//         "exe_wd_foaming",
//         "exe_wd_garage_gate_installation",
//         "exe_wd_garage_gate_supply",
//         "exe_wd_interior_door_installation",
//         "exe_wd_interior_door_supply",
//         "exe_wd_leveler",
//         "exe_wd_outer_door_installation",
//         "exe_wd_outer_door_supply",
//         "exe_wd_powerdrilldrillbit_expansionplug_woodworkscrew_powerdrill",
//         "exe_wd_roof_window_installation",
//         "exe_wd_roof_window_supply",
//         "exe_wd_strut",
//         "exe_wd_technical_door_installation",
//         "exe_wd_technical_door_supply",
//         "exe_wd_tool_rack_1",
//         "exe_wd_tool_rack_boxes",
//         "exe_wd_vertical_window_installation",
//         "exe_wd_vertical_window_supply",
//         "exe_wd_wedge_hammer",
//       ],
//     },
//     {
//       name: "Obrona Cywilna",
//       elements: ["exe_cd_essential_items"],
//     },
//     {
//       name: "Konstrukcja",
//       elements: [
//         "env_wall_column_05",
//         "env_wall_creator_x2_5",
//         "envp_modular_door_frame",
//         "exe_creator_door_office_double",
//         "exe_creator_door_wooden_1",
//         "elevator_1x2.1x",
//         "env_staircase_stairs",
//       ],
//     },
//   ];

//   const groupedModels = sections.map((section) => {
//     const filteredElements = models.filter((model) => {
//       const modelName = model.endpointData?.name;

//       if (!modelName) return false;

//       const belongsToSection = section.elements.includes(modelName);

//       if (query.trim() === "") {
//         return belongsToSection;
//       }

//       return (
//         belongsToSection &&
//         modelName.toLowerCase().includes(query.toLowerCase())
//       );
//     });

//     return {
//       ...section,
//       models: filteredElements,
//     };
//   });

//   console.log("groupedModels", groupedModels);

//   return (
//     <Paper
//       component="form"
//       onSubmit={searchModel}
//       sx={{
//         p: "2px 4px",
//         display: "flex",
//         alignItems: "center",
//         mb: 2,
//         mt: 2,
//         bgcolor: "#e4e6e6ff",
//       }}
//     >
//       <InputBase
//         sx={{ ml: 1, flex: 1 }}
//         placeholder="Wyszukaj model"
//         value={query}
//         onChange={handleChange}
//         inputProps={{ "aria-label": "Wyszukaj model" }}
//       />
//       <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
//       {/* <IconButton type="submit" sx={{ p: "10px" }} aria-label="search"> */}
//       <SearchIcon color="primary" />
//       {/* </IconButton> */}
//     </Paper>
//   );
// }

// export default function ModelList({ addModel, MODEL_LIBRARY }) {
//   const [models, setModels] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [filteredModels, setFilteredModels] = useState(models);

//   // console.log("filteredModels", filteredModels);

//   useEffect(() => {
//     const fetchAllModels = async () => {
//       const visibleModels = MODEL_LIBRARY.filter((m) => m.visible);

//       try {
//         const modelsWithData = await Promise.all(
//           visibleModels.map(async (model) => {
//             try {
//               const response = await fetch(
//                 `https://vralfa.vccsystem.eu/manifest/api/${model.name}.manifest&0`,
//               );
//               const data = await response.json();
//               return { ...model, endpointData: data };
//             } catch (err) {
//               console.error(`Błąd pobierania ${model.name}:`, err);
//               return { ...model, endpointData: null };
//             }
//           }),
//         );

//         setModels(modelsWithData);
//       } catch (err) {
//         console.error("Błąd pobierania modeli:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAllModels();
//   }, []);

//   const modelsToDisplay =
//     filteredModels && filteredModels.length > 0 ? filteredModels : models;

//   if (loading)
//     return (
//       <Box sx={{ display: "flex", justifyContent: "center", my: 10 }}>
//         <CircularProgress />
//       </Box>
//     );

//   return (
//     <>
//       <SearchBar models={models} onSearch={setFilteredModels} />

//       <List
//         dense
//         sx={{ maxHeight: 300, overflowY: "auto", overflowX: "hidden" }}
//       >
//         {modelsToDisplay.map((m) => (
//           <TooltipWithDelay
//             key={m.name}
//             title={
//               m.endpointData
//                 ? m.endpointData?.info?.descreption || "Brak opisu"
//                 : "Brak danych"
//             }
//           >
//             <ListItem key={m.name} disablePadding>
//               <ListItemButton onMouseDown={() => addModel(m.name)}>
//                 <ListItemText
//                   //   primary={m.name}
//                   //   secondary={
//                   //     m.endpointData
//                   //       ? JSON.stringify(m.endpointData?.exercise?.name)
//                   //       : "Brak danych"
//                   //   }
//                   primary={
//                     m.endpointData?.info?.name
//                       ? m.endpointData?.info?.name
//                       : m.name
//                   }
//                   // secondary={
//                   //   m.endpointData
//                   //     ? m.endpointData?.exercise?.descreption
//                   //     : "Brak danych"
//                   // }
//                 />
//               </ListItemButton>
//             </ListItem>
//           </TooltipWithDelay>
//         ))}
//       </List>
//     </>
//   );
// }

// function TooltipWithDelay({ children, title }) {
//   const [open, setOpen] = useState(false);
//   let timeout;

//   const handleMouseEnter = () => {
//     timeout = setTimeout(() => setOpen(true), 1000);
//   };

//   const handleMouseLeave = () => {
//     clearTimeout(timeout);
//     setOpen(false);
//   };

//   return (
//     <Tooltip
//       title={title}
//       open={open}
//       onMouseEnter={handleMouseEnter}
//       onMouseLeave={handleMouseLeave}
//       disableHoverListener
//       disableFocusListener
//       disableTouchListener
//     >
//       {children}
//     </Tooltip>
//   );
// }
